(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["livana-circulation-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('livana-reference-videos')) {
    customElements.define('livana-reference-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('.circulation-videos__track');
        const videos = [...this.querySelectorAll('video')];
        if (!track || !videos.length) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const pauseAll = () => videos.forEach((video) => video.pause());

        videos.forEach((video) => {
          const button = video.nextElementSibling;
          if (!button) return;
          const nativeControls = () => {
            video.pause();
            video.controls = true;
            button.hidden = true;
          };
          const sync = () => {
            button.classList.toggle('is-playing', !video.paused);
            button.setAttribute('aria-label', video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
          };
          video.controls = false;
          button.hidden = false;
          video.addEventListener('play', () => {
            videos.forEach((other) => { if (other !== video) other.pause(); });
            sync();
          }, { signal });
          video.addEventListener('pause', sync, { signal });
          video.addEventListener('ended', sync, { signal });
          video.addEventListener('error', nativeControls, { signal });
          button.addEventListener('click', async () => {
            if (!video.paused) {
              video.pause();
              return;
            }
            video.muted = false;
            try {
              await video.play();
            } catch {
              // Browser controls expose retry, seeking and media errors.
              nativeControls();
            }
          }, { signal });
          sync();
        });

        this.querySelector('.circulation-videos__navigation').hidden = false;
        const arrows = [...this.querySelectorAll('[data-video-direction]')];
        const syncArrows = () => {
          const overflow = track.scrollWidth - track.clientWidth;
          arrows.forEach((button) => {
            const backwards = Number(button.dataset.videoDirection) < 0;
            button.disabled = overflow > 1 && (backwards ? track.scrollLeft <= 0 : track.scrollLeft >= overflow - 1);
          });
        };
        this.frame = 0;
        track.addEventListener('scroll', () => {
          if (typeof requestAnimationFrame !== 'function') {
            syncArrows();
            return;
          }
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; syncArrows(); });
        }, { signal, passive: true });
        window.addEventListener('resize', syncArrows, { signal });
        syncArrows();
        arrows.forEach((button) => {
          button.addEventListener('click', () => {
            const step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
            const left = step * Number(button.dataset.videoDirection);
            if (typeof track.scrollBy === 'function') track.scrollBy({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
            else track.scrollLeft += left;
          }, { signal });
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) pauseAll();
        }, { signal });
        window.addEventListener('pagehide', pauseAll, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { if (!entry.isIntersecting) entry.target.pause(); });
          }, { threshold: 0 });
          videos.forEach((video) => this.observer.observe(video));
        }
      }

      disconnectedCallback() {
        this.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.controls = true;
          if (video.nextElementSibling) video.nextElementSibling.hidden = true;
        });
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(this.frame);
        this.frame = 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
